import { UseMutationResult, useMutation } from 'react-query';

import { getTokenWithType } from './useAuth';

import { procedureDownload } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

function generatePdf(htmlContent: string) {
  const parser = new DOMParser();
  const document = parser.parseFromString(htmlContent, 'text/html');
  const images = document.querySelectorAll('img');
  images.forEach(img => {
    const imageResizingStyle =
      'max-inline-size: 100% !important; block-size: auto !important;';
    const existingStyle = img.getAttribute('style');
    img.setAttribute(
      'style',
      existingStyle
        ? `${existingStyle}; ${imageResizingStyle}`
        : imageResizingStyle,
    );
  });
  const content = new XMLSerializer().serializeToString(document);
  const blob = new Blob([content], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const newWindow = window.open(url, '_blank');

  newWindow?.addEventListener('load', () => {
    newWindow.onafterprint = () => {
      newWindow.close();
    };

    setTimeout(() => {
      newWindow.print();
    }, 100);
  });
}
async function fetchHtmlContent({
  payload,
  accountId,
  pListName,
  singlePdf,
}: TVariables): Promise<any> {
  const response = await fetch(
    procedureDownload(accountId, payload, pListName, singlePdf),
    {
      method: 'GET',
      headers: {
        Authorization: getTokenWithType(),
      },
    },
  );
  return response.text();
}

type TError = ErrorModal;

type TVariables = {
  accountId: number;
  payload: string;
  pListName?: string;
  singlePdf?: boolean;
};

type TSnapshot = unknown;

function useSaveProcedureAsPDF(): UseMutationResult<
  void,
  TError,
  TVariables,
  TSnapshot
> {
  return useMutation(
    async ({
      accountId,
      payload,
      pListName,
      singlePdf,
    }: TVariables): Promise<void> => {
      const fetchResponse = await fetchHtmlContent({
        accountId,
        payload,
        pListName,
        singlePdf,
      });
      if (fetchResponse) {
        generatePdf(fetchResponse);
      }
      return;
    },
  );
}

export { useSaveProcedureAsPDF };
